<template>
  <div class="logos-container">
    <div v-if="index > 0" class="header--center__separator"></div>
    <component :is="logoUrl !== 'unset' ? 'a' : 'span'" :href="logoUrl">
      <picture :aria-label="logo.ariaLabel" :class="['svg-logo header--center__logo', pictureClass]">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div
          v-if="logo.inline"
          class="header--center__logo-svg"
          :class="logo.logoClass"
          :title="logo.ariaLabel"
          v-html="logo.screenSize[currentScreen]"
        />
        <img v-else class="header--center__logo-img" :alt="logo.ariaLabel" :src="logo.screenSize[currentScreen]" />
      </picture>
    </component>
  </div>
</template>

<script>
import variables from "@/styles/variables.scss";

export default {
  name: "LogosContainer",
  // TODO: usare il mixin handleWindowResize già presente?
  mixins: [],
  props: {
    headerSearchOpen: {
      type: Boolean,
      default: false,
    },
    index: {
      type: Number,
      default: 0,
    },
    logo: {
      type: Object,
      required: true,
      default: () => ({
        ariaLabel: {
          type: String,
          required: true,
        },
        pictureClass: {
          type: Object,
          required: true,
          default: () => ({
            transparent: {
              type: String,
              required: true,
            },
            desktop: {
              type: String,
              required: true,
            },
            mobile: {
              type: String,
              required: true,
            },
          }),
        },
        screenSize: {
          transparent: {
            type: String,
            required: true,
          },
          desktop: {
            type: String,
            required: true,
          },
          mobile: {
            type: String,
            required: true,
          },
        },
        inline: {
          type: Boolean,
          default: false,
        },
        logoClass: {
          type: String,
          default: false,
        },
        url: {
          type: String,
          required: true,
        },
      }),
    },
    transparent: {
      type: Boolean,
      default: false,
    },
    sections: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      windowWidth: 0,
    };
  },
  computed: {
    currentScreen() {
      if ((this.headerSearchOpen && this.logo.mobileOnSearchOpen) || this.windowWidth < variables.bpSizeLarge) {
        return "mobile";
      }
      if (this.transparent) {
        return "transparent";
      }
      return "desktop";
    },
    pictureClass() {
      if (this.logo.pictureClass) {
        return this.logo.pictureClass[this.currentScreen];
      }
      return "";
    },
    logoUrl() {
      /**
       * Logo URL can be either the url property on the logo object, or, if empty, the URL of the first non empty section.
       *
       * URL fallbacks to home if both logo URL and sections URL are all empty.
       *
       * Logo url attribute must be set to "unset" string if one does not want to create a link for the logo image.
       */
      let sectionsWithUrls = [];
      if (this.sections) {
        sectionsWithUrls = Object.values(this.sections).filter(
          item => typeof item === "object" && item.url && item.url.length > 0
        );
      }
      if (sectionsWithUrls.length > 0) return this.logo.url ? this.logo.url : sectionsWithUrls[0].url;
      return this.logo.url ? this.logo.url : "/";
    },
  },
  created() {
    window.addEventListener("resize", this.handleResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.handleResize);
  },
  mounted() {
    this.handleResize();
  },
  methods: {
    // TODO: Capire se la gestione del resize rimane interna al componente o è gestita da un mixin globale
    handleResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

$dea-logo-center-size: 112px;
$dea-logo-center-size--mobile: 44px;

.logos-container {
  align-items: center;
  display: flex;
  flex-direction: row;

  .header--center__separator {
    background: $dea-color-grey-medium-light;
    height: $space-x-large;
    width: 1px;
  }

  .header--center__logo {
    @include media("<m") {
      height: $dea-logo-center-size--mobile;
      width: $dea-logo-center-size--mobile;
    }
    display: flex;
    height: auto;
    margin: 0 $space-x-small;
    width: $dea-logo-center-size;

    &-img,
    &-svg {
      height: auto;
      width: 100%;
    }
  }
}
</style>
